<template>
  <div v-show="inMeeting && inWaiting">
    <div class="rounded waiting mx-auto">
      <div
        class="small-ctrl"
        @click="$parent.exitMeeting">
        {{ meetingInfo.webinar ? $t('MEETING.LEAVE_WEBINAR') : $t('MEETING.LEAVE_MEETING') }}
      </div>
      <div
      class="text-center">
        <div class="title">{{ meetingInfo.title }}</div>
        <div class="start-time">{{ meetingInfoStart }}</div>
        <div class="spinner-border text-primary m-4">
          <span class="sr-only">{{ $t('MEETING.LOADING') }}</span>
        </div>
        <div class="start-time">{{ meetingInfo.webinar ? $t('MEETING.WAITING_DESCRIPTION_WEBINAR') : $t('MEETING.WAITING_DESCRIPTON_WAIT') }}</div>
        <b-row
          style="margin-top:16px"
          align-h="center">
          <div
            v-show="meetingInfo.webinar"
            class="small">
            {{ $t('MEETING.WEBINAR_ARE_MODERATOR') }}
          </div>
          <div
            style="margin-left:7px"
            class="small-ctrl"
            @click="launchMakeModerator">
            {{ $t('MEETING.ENTER_MOD_KEY') }}
          </div>
        </b-row>
        <b-row
          v-show="meetingInfo.webinar"
          style="margin-top:5px"
          align-h="center">
          <div class="small">
            {{ $t('MEETING.WEBINAR_ARE_SPEAKER') }}
          </div>
          <div
            style="margin-left:7px"
            class="small-ctrl"
            @click="launchSpeakerPin">
            {{ $t('MEETING.WAITING_ENTER_SPEAKERPIN') }}
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import {ref, computed} from "@vue/composition-api"
import ModeratorKeyIcon from "../icons/ModeratorKey"
  export default {
    name: 'WaitingRoom',
    components: {
      ModeratorKeyIcon
    },
    props: {
      inWaiting: {
        type: Boolean,
        default: true
      },
      inMeeting: {
        type: Boolean,
        default: false
      },
      meetingInfo: {
        type: Object,
        default: () => {}
      }
    },
    setup(props, context) {
      const meetingInfoStart = computed(() => {
        let dateObject = new Date(props.meetingInfo.start)
        return dateObject.toLocaleString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true
        })
      })

      function launchMakeModerator() {
        this.$bvModal.show('modal-make-moderator')
      }

      function launchSpeakerPin() {
        this.$bvModal.show('modal-make-speaker')
      }

      return {
        meetingInfoStart,
        launchMakeModerator,
        launchSpeakerPin
      }
    }
  }
</script>
<style scoped>
  .spinner-border{
    width: 56px;
    height: 56px;
  }
  .waiting{
    background: #272727;
    max-width: 500px;
    padding: 20px;
    margin-top: 80px;
  }
  .title{
    color: #ffffff;
    font-size: 28px;
    cursor:default;
  }
  .small{
    font-size: 12px;
    font-weight: 600;
    color: #bbbbbb;
    cursor:default;
  }
  .small-ctrl{
    font-size: 12px;
    font-weight: 600;
    color: #2491FF;
    cursor:pointer;
  }
  .start-time{
    font-size: 16px;
    color: #bbbbbb;
    cursor:default;
  }
  .mod-title {
    width: 348px;
    margin: 16px;
  }
  .mod-text {
    color: #282828;
    font-weight: 600;
    line-height: 24px;
    font-size: 16px;
    margin-left: 8px;
  }
  .mod-input {
    width: 316px;
    height: 48px;
    margin-left: 46px;
  }
  .mod-btns {
    margin-top: 34px;
    margin-left: 203px;
    padding-right: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/WaitingRoom.vue